import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_1yelunfq: FaireBrandEntity = {
  token: "b_1yelunfq",
  type: "brand",
  name: "Beauty By Earth",
  avatarUrl:
    "https://cdn.faire.com/fastly/345b7b80e996c78a44f69eb69ca1597ce45770c41fa6e5f30d7f6b0b0ad8076b.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d20f8667d3742719ad20953082fa2d6e32ad6ed4a5e7f226fbe73562ddd63fad.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/345b7b80e996c78a44f69eb69ca1597ce45770c41fa6e5f30d7f6b0b0ad8076b.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d20f8667d3742719ad20953082fa2d6e32ad6ed4a5e7f226fbe73562ddd63fad.webp",
  location: "Carrollton, TX, USA",
  minimumOrderDollars: 0,
  rating: 4.9,
  reviewCount: 86,
  isInsider: true,
  description:
    "Here at Beauty by Earth, we’re devoted to pure, effective ingredients that overflow with natural goodness. Our award-winning, non-toxic and always cruelty-free products unleash your natural beauty while helping you, your family and the planet thrive. Why? Because we believe everyone deserves skincare products that bring out their best, without hidden toxins or ludicrous price tags.\n\nOur passion for natural, high-performing, safe ingredients was born with the birth of our kids (pun intended). We were fed up with the skincare industry’s casual disregard for our family’s health. Every time we put on sunscreen, we traded protection from the sun for exposure to harmful toxins. Enough was enough!\n\nThat’s how two friends became founders and co-owners of one of the fastest-growing companies in the U.S.\n\nThere can be a lot of hype when it comes to organic, natural and non-toxic skincare products, so when it comes down to it, ingredients really do tell all.\n\nWe’re on a mission to create the most effective products with the cleanest ingredients that can be found on earth.\n\nToday, you can find Beauty by Earth products on our website, our app, on Amazon, Target.com, Walmart.com, Grove.com, and so many more stores!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:04.942Z",
    importedBy: "entity-db-cli",
  },
};
